import * as React from "react";
import * as staticUrls from "../../constants/static-urls";
import styled from "styled-components";

/** PackageComparisonHeaderElement */
interface PackageComparisonHeaderElementProps {
  packageName: string
  buttonColor: "" | "blue" | "grey" | "indigo" | "cyan"
  buttonLinkTo: string
}

const PackageComparisonHeaderElement = (props: PackageComparisonHeaderElementProps) => {
  const {packageName,buttonColor,buttonLinkTo} = props;
  return (
    <PackageComparisonHeaderElementWrapper>
      <p>{packageName}</p>
      <div className="text-center mt-30">
        <a href={buttonLinkTo} target="_blank" className={`btn btn-md waves-effect waves-light ${buttonColor}`}>Wypróbuj za darmo</a>
      </div>
    </PackageComparisonHeaderElementWrapper>
  );
};

/** STYLES => PackageComparisonHeaderElement */

const PackageComparisonHeaderElementWrapper = styled.div`
  flex-basis: 30%;
  max-width: 300px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-top: 30px;
  padding-bottom: 10px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  p {
    margin: 0;
    text-align: center;
    color: #202020;
    font-weight: bold;
    font-size: 20px;
    text-transform: uppercase;
  }
  a {
    font-size: 12px !important;
    font-weight: bold;
  }
`;

/** PackageComparisonHeader */
interface PackageComparisonHeaderProps {}

const PackageComparisonHeader = (props: PackageComparisonHeaderProps) => {
  return (
    <PackageComparisonWrapper>
      <PackageComparisonHeaderElementPositioner/>
      <PackageComparisonHeaderElement
        packageName="Pakiet darmowy"
        buttonColor=""
        buttonLinkTo={staticUrls.FAKTUROMANIA_REGISTRATION_PAGE_URL}
      />
      <PackageComparisonHeaderElement
        packageName="Pakiet premium"
        buttonColor=""
        buttonLinkTo={staticUrls.FAKTUROMANIA_REGISTRATION_PAGE_URL}
      />
    </PackageComparisonWrapper>
  )
};

/** STYLES => PackageComparisonHeader */

const PackageComparisonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-right: 2px;
`;

const PackageComparisonHeaderElementPositioner = styled.div`
  flex-basis: 40%;
`;


export default PackageComparisonHeader


// WEBPACK FOOTER //
// ./src/layouts/package-comparison-block/package-comparison-header.tsx